<script>
import { searchService } from "../../services";
import { required, requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from "vue-multiselect";
import { routes } from '../../config/api_routes';

export default {
  components: { searchService, Layout, PageHeader, Multiselect},
    data() {
        return {
            items: [],
            name: [],
            isLoading: false,
            config: config,
            typeform: {
                type: "",
                type_id: "",
                name:""
            },
        };
    },
    validations: {
        typeform: {
            type: {
                required,
            },
            name: {
                required: requiredIf(function (nestedModel) {
                    return (
                        this.typeform.name == 0
                    );
                }),
            }
        }
    },
    mounted(){
        this.getData();
        this.getPopularSearchById();
    },
    methods: {
        editPopularSearch(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $(".is-invalid:first").focus();
                },500);
                return;
            } else {
                searchService.editPopularSearch(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        this.$router.push({ name: "popular-search" });
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        getData(){
            searchService.getPopularSearchData({type : this.$route.params.type})
            .then((response) => {
                // this.items = response.data.result;
                this.items = response.data.result.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
            });
        },
        getPopularSearchById(){
            searchService.getPopularSearchById({id: this.$route.params.id})
            .then((response) => {
                this.typeform = response.data.result;
            });
        },
        asyncPopularSearch(query) {
            this.isLoading = true;
            searchService.getPopularSearch({ search: query, type: this.$route.params.type })
            .then((response) => {
                // this.items = response.data.result;
                this.items = response.data.result.sort((a, b) => {
                    return a.name.name.localeCompare(b.name.name);
                });
                this.isLoading = false;
            });
        },
    },
};

</script>
<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
                    <div class="page-title-left avatar-main-icon">
                        <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-briefcase"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18">{{ typeform.type }}</h4>
                            <p>
                                <router-link :to="{ name: 'popular-search'}">{{ trans.get('__JSON__.Popular Search') }}</router-link>
                                > {{ typeform.type }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="editPopularSearch">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">{{ trans.get('__JSON__.Popular Search') }}</h4>
                            <p class="card-title-desc"></p>
                            <div class="row">
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Select Type') }}</label>
                                        <select class="custom-select" v-model="typeform.type" @change="getData($event)" :class="{ 'is-invalid':$v.typeform.type.$error }" :disabled="true">
                                            <option value="" selected>{{ trans.get('__JSON__.Please Select Type') }}</option>
                                            <option value="Category">{{ trans.get('__JSON__.Category') }}</option>
                                            <option value="SubCategory">{{ trans.get('__JSON__.Sub Category') }}</option>
                                            <option value="Product">{{ trans.get('__JSON__.Product') }}</option>
                                            <option value="Brand">{{ trans.get('__JSON__.Brand') }}</option>
                                        </select>
                                        <div v-if="$v.typeform.type.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.type.required">{{ trans.get('__JSON__.Please select type') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Select Popular',{lang: this.typeform.type }) }}</label>
                                        <div class="position-relative">
                                            <multiselect
                                                v-model="$v.typeform.name.$model"
                                                id="name"
                                                label="name"
                                                track-by="name"
                                                :placeholder="trans.get('__JSON__.Sub Category Search')"
                                                open-direction="bottom"
                                                :options="items"
                                                :searchable="true"
                                                :loading="isLoading"
                                                :internal-search="true"
                                                :clear-on-select="true"
                                                :close-on-select="true"
                                                :max-height="600"
                                                :show-no-results="false"
                                                :hide-selected="true"
                                                @search-change="asyncPopularSearch"
                                                :class="{ 'is-invalid': $v.typeform.name.$error}"
                                            >
                                                <template slot="tag" slot-scope="{ option, remove }">
                                                    <span class="custom__tag">
                                                        <span>{{ option.name }}</span>
                                                        <span class="custom__remove" @click="remove(option)">❌</span>
                                                    </span>
                                                </template>
                                                <template slot="clear" slot-scope="props">
                                                    <div
                                                        class="multiselect__clear"
                                                        v-if="name.length"
                                                        @mousedown.prevent.stop="clearAll(props.search)"
                                                    ></div>
                                                </template>
                                                <span slot="noResult">{{ trans.get( "__JSON__.Oops! No elements found. Consider changing the search query") }}.</span>
                                            </multiselect>
                                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please select',{lang: this.typeform.type }) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                                    <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </Layout>
</template>